import {Component, Directive, EventEmitter, Input, NgModule, Output} from '@angular/core';

@Component({
  selector: 'sd-tab-group',
  standalone: true,
  template: `
    <div class="sd-tabs flex flex-wrap gap-1 border-b border-[var(--m365-border-rest,#ececf0)]">
      @for (tab of tabs; track $index) {
        <button
          type="button"
          class="px-3 py-2 text-sm"
          [class.border-b-2]="selectedIndex === $index"
          [class.border-neutral-900]="selectedIndex === $index"
          [class.font-semibold]="selectedIndex === $index"
          (click)="select($index)"
        >{{ tab.label }}</button>
      }
    </div>
    <div class="sd-tabs__body pt-3">
      <ng-content></ng-content>
    </div>
  `,
  host: {class: 'sd-tab-group sd-tab-group block'},
})
export class SdTabGroup {
  @Input() selectedIndex = 0;
  @Input() color: string | undefined;
  @Input() animationDuration: string | undefined;
  @Output() selectedIndexChange = new EventEmitter<number>();
  @Output() selectedTabChange = new EventEmitter<{index: number}>();
  tabs: SdTab[] = [];

  register(tab: SdTab): void {
    if (!this.tabs.includes(tab)) {
      this.tabs.push(tab);
      tab.active = this.tabs.length - 1 === this.selectedIndex;
    }
  }

  select(index: number): void {
    this.selectedIndex = index;
    this.tabs.forEach((tab, i) => (tab.active = i === index));
    this.selectedIndexChange.emit(index);
    this.selectedTabChange.emit({index});
  }
}

@Component({
  selector: 'sd-tab',
  standalone: true,
  template: `@if (active) {<ng-content></ng-content>}`,
  host: {class: 'sd-tab block'},
})
export class SdTab {
  @Input() label = '';
  active = false;

  constructor(group: SdTabGroup) {
    group.register(this);
  }
}

@Component({
  selector: 'sd-tab-label, [sd-tab-label]',
  standalone: true,
  template: `<ng-content></ng-content>`,
})
export class SdTabLabel {}

@Component({
  selector: 'sd-tab-nav-bar, nav[sd-tab-nav-bar]',
  standalone: true,
  template: `<ng-content></ng-content>`,
  host: {class: 'sd-tab-nav flex flex-wrap gap-1 border-b border-[var(--m365-border-rest,#ececf0)]'},
})
export class SdTabNav {
  @Input() tabPanel: SdTabNavPanel | null = null;
}

@Directive({
  selector: '[sd-tab-link], [sdTabLink]',
  standalone: true,
  host: {
    class: 'sd-tab-link inline-flex px-3 py-2 text-sm',
    '[class.font-semibold]': 'active',
    '[class.border-b-2]': 'active',
    '[class.sd-tab-link--active]': 'active',
  },
})
export class SdTabLink {
  @Input() active = false;
}

@Component({
  selector: 'sd-tab-nav-panel',
  standalone: true,
  template: `<ng-content></ng-content>`,
  host: {class: 'sd-tab-nav-panel block'},
})
export class SdTabNavPanel {}

@NgModule({
  imports: [SdTabGroup, SdTab, SdTabLabel, SdTabNav, SdTabLink, SdTabNavPanel],
  exports: [SdTabGroup, SdTab, SdTabLabel, SdTabNav, SdTabLink, SdTabNavPanel],
})
export class SdTabsModule {}
